import { HttpUrlEncodingCodec } from "@angular/common/http";
import { AfterViewInit, Component, Input, OnDestroy } from "@angular/core";
import { StaticPagesService } from "src/app/Services/static-pages.service";
@Component({
  selector: "app-bread-crumbs",
  templateUrl: "./bread-crumbs.component.html",
  styleUrls: ["./bread-crumbs.component.scss"],
})
export class BreadCrumbsComponent implements OnDestroy, AfterViewInit {
  @Input() routes: Array<any> = [];
  @Input() lang: string = "";
  @Input() productName: string = "";
  codec = new HttpUrlEncodingCodec();
  environmentVariables: any;
  subscription: any;

  constructor(private confgServ: StaticPagesService) {
    this.getInitilizingData();
  }

  ngAfterViewInit(): void {
    console.log('productName', this.productName)
    if (this.routes.map(n => n.name)[0] !== undefined) {
      const uniqueRoutes = Array.from(new Set(this.routes.map(route => route.name)))
        .map(name => this.routes.find(route => route.name === name));
      this.routes = uniqueRoutes;
    }

    let slugs = this.routes.map(x => x.slug);
    if (this.routes) {
      let cobyRoutes = [...this.routes]
      cobyRoutes.unshift({ name_en: 'Home' });
      let items = cobyRoutes.map((x, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@id": index === 0 ? this.environmentVariables.WEBSITE_URL : this.environmentVariables.WEBSITE_URL + '/product/' + slugs.slice(0, index).join('/'),
          name: x.name_en,
        }
      }));
      const script = document.createElement('script');
      script.type = 'application/ld+json';

      script.text = `{
                "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": ${JSON.stringify(items)}
          }
        `
      document.body.appendChild(script);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getInitilizingData() {
    this.subscription = this.confgServ.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
    });
  }

  getParentSlug1(slug: any) {
    console.log(slug);
    return slug[0].slug;
  }

  getLastParentSlug1(slug: any) {
    console.log(slug);
    return slug[slug?.length - 1].parent_slug;
  }

  generateRouterLink(item: any, index: number): any[] {

    //************ */
   if (index === 0 && !item?.list_id) {
      return ['/', this.lang, 'product', item?.slug];
    } else if (index === 1) {
      return ['/', this.lang, 'product', this.routes[0]?.slug, item?.slug];
    } else if (item?.slug) {
      const parentSlugs = this.getParentSlugs(index);
      // console.log(...parentSlugs);
      
      return ['/', this.lang, 'product', ...parentSlugs, item?.slug];
    }
    return ['/', this.lang, 'products'];
  }

  getParentSlugs(index: number): string[] {
    const parentSlugs: string[] = [];
    for (let i = 0; i < index; i++) {
      if (this.routes[i] && this.routes[i].slug) {
        parentSlugs.push(this.routes[i].slug);
      }
    }
    return parentSlugs;
  }
}

